import { render } from "./LogoutPage.vue?vue&type=template&id=afa704b4&ts=true"
import script from "./LogoutPage.vue?vue&type=script&lang=ts"
export * from "./LogoutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__